import { Button } from 'antd';
import React from 'react';
import { DeleteOutlined } from '@ant-design/icons';

import { ColourPicker, NumberField, Switch } from '../../../WidgetConfiguratorComponents/FormGroups';
import { LineStyleFormGroup } from '../LineStyleFormGroup';
import { HorizontalLine } from '../types';

interface HorizontalLineProps {
    horizontalLine: HorizontalLine;
    onUpdate: (newHorizontalLine: HorizontalLine) => void;
    onDelete: () => void;
}

const HorizontalLine = ({ onUpdate, horizontalLine, onDelete }: HorizontalLineProps) => (
    <>
        <NumberField label='Y value' step={0.5} value={horizontalLine.y} onChange={(y: number) => onUpdate({ ...horizontalLine, y })} />
        <LineStyleFormGroup value={horizontalLine.lineStyle} onChange={(lineStyle) => onUpdate({ ...horizontalLine, lineStyle })} />
        <ColourPicker value={horizontalLine.stroke} onChange={(stroke) => onUpdate({ ...horizontalLine, stroke })} />
        <Switch
            label='Display value'
            value={horizontalLine.yValueVisible}
            onChange={(yValueVisible: boolean) => onUpdate({ ...horizontalLine, yValueVisible })}
        />
        <div style={{ gridColumn: '1 / 6', textAlign: 'right' }}>
            <Button danger icon={<DeleteOutlined />} onClick={onDelete}>
                Delete
            </Button>
        </div>
    </>
);

export default HorizontalLine;
